"use strict";
exports.__esModule = true;
exports.SvgTour = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgTour = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", d: "M2.574 5.212l6.412-1.199a.751.751 0 01.313.007l5.559 1.313 6.288-1.19c.386-.072.763.163.84.524.01.044.014.087.014.131v13.335c0 .318-.24.592-.574.655l-6.41 1.199a.755.755 0 01-.314-.007l-5.559-1.3-6.289 1.177c-.386.072-.763-.163-.84-.524A.584.584 0 012 19.202V5.867c0-.318.24-.592.574-.655zm.855 1.203v11.972l5.714-1.054 5.715 1.334 5.713-1.082V5.613l-5.713 1.054-5.715-1.334L3.43 6.415zm4.286-.812l1.428-.27v12l-1.428.273V5.603zm7.143 1.064l1.428-.265V18.4l-1.428.267v-12z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Tour.js.map